import { Injectable, EventEmitter, Output } from '@angular/core';
import { Xelement } from './xElement.interface';
import { Size } from '../Classes/sizeClass.class';
import {
    Directive,
    ElementRef,
    HostListener,
    HostBinding,
    Input,
    AfterContentInit,
    ContentChildren,
    QueryList
} from '@angular/core';

@Directive({
    selector: '[dock]'
})

export class DockDirective implements AfterContentInit {

    private parent: Element;

    @Input('dock') dock: any;
    @Output() resized = new EventEmitter<Size>();

    @HostBinding('style.height.px') height: number;
    @HostBinding('style.top.px') top: number;
    @HostBinding('style.left.px') left: number;
    @HostBinding('style.width.px') width: number;
    @HostBinding('style.display') display: string = 'block';
    @HostBinding('style.position') pos: string = 'absolute';
    @HostBinding('style.overflow') overflow: string = 'hidden';

    @ContentChildren(DockDirective) private children: QueryList<DockDirective>;

    constructor(private el: ElementRef) {
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.setDock('onResize');
    }

    ngAfterContentInit(): void {
        this.el.nativeElement.docked = this.dock;
        this.parent = this.el.nativeElement.parentElement;
        this.top = this.el.nativeElement.clientTop;
        this.left = this.el.nativeElement.clientLeft;
        this.height = this.el.nativeElement.clientHeight;
        this.width = this.el.nativeElement.clientWidth;

        setTimeout(() => {
            this.setDock('contentInit');
        }, 1);
    }

    setDock(caller: string) {
        var rect = this.parent.getBoundingClientRect();
        var siblings: HTMLCollection = this.parent.children;
        if (this.dock === 'left') {
            this.dockLeft(rect, siblings);
        }
        if (this.dock === 'top') {
            this.dockTop(rect, siblings);
        }
        if (this.dock === 'bottom') {
            this.dockBottom(rect, siblings);
        }
        if (this.dock === 'fill') {
            this.dockFill(rect, siblings);
        }
        this.children.forEach((child: DockDirective) => {
            if (child !== this) {
                setTimeout(() => {
                    child.setDock('SetDock-' + caller);
                }, 1);
            }
        });
        // this.resized.emit(new Size(this.left, this.top, this.width, this.height));
    }


    private dockBottom(parentRect: ClientRect, siblings: HTMLCollection) {
        let rightMost = 0;
        let topMost = 0;
        let leftMost = 0;
        let bottomMost = 0;

        for (let index = 0; index < siblings.length; index++) {
            let element: Xelement = siblings[index];
            if (element === this.el.nativeElement) {
                break;
            }
            if (element.docked) {
                let rect = element.getBoundingClientRect();
                if (element.docked === 'left' &&
                    (this.isBetween(this.top, rect.top, rect.top + rect.height) ||
                        (this.isBetween(this.top + this.height, rect.top, rect.top + rect.height)))) {
                    leftMost = Math.max(leftMost, (rect.left + rect.width));
                }
                if (element.docked === 'bottom' &&
                    (this.isBetween(this.left, rect.left, rect.left + rect.width) ||
                        (this.isBetween(this.left + this.width, rect.left, rect.left + rect.width)))) {
                    bottomMost = Math.max(bottomMost, (rect.top + rect.height));
                }
            }
        }
        this.left = leftMost;
        this.top = this.parent.clientHeight - bottomMost - this.height;
        this.width = this.parent.clientWidth - leftMost;
        // console.log('Docked at bottom: ' + this.el.nativeElement.className + ' top: '+ this.top + ' height:' + this.height);
    }

    private dockFill(parentRect: ClientRect, siblings: HTMLCollection) {
        let rightMost = 0;
        let topMost = 0;
        let leftMost = 0;
        let bottomMost = 0;

        for (let index = 0; index < siblings.length; index++) {
            let element: Xelement = siblings[index];
            if (element === this.el.nativeElement) {
                break;
            }
            if (element.docked) {
                let rect = element.getBoundingClientRect();
                if (element.docked === 'left' &&
                    (this.isBetween(this.top, rect.top, rect.top + rect.height) ||
                        (this.isBetween(this.top + this.height, rect.top, rect.top + rect.height)))) {
                    leftMost = Math.max(leftMost, (rect.left + rect.width));
                }
                if (element.docked === 'top') {
                    // &&
                    // ( this.isBetween( this.left, rect.left, rect.left + rect.width ) ||
                    //     ( this.isBetween( this.left + this.width, rect.left, rect.left + rect.width ) ) ) ) {
                    // topMost = Math.max( topMost, ( rect.height ) );
                    topMost += (rect.height);
                }
                if (element.docked === 'bottom') {
                    bottomMost += rect.height;
                    // &&
                    // ( this.isBetween( this.left, rect.left, rect.left + rect.width ) ||
                    //     ( this.isBetween( this.left + this.width, rect.left, rect.left + rect.width ) ) ) ) {
                    // bottomMost = Math.max( bottomMost, ( rect.height ) );
                }
            }
        }
        this.left = leftMost;
        this.top = topMost;
        this.height = this.parent.clientHeight - topMost - bottomMost;
        this.width = this.parent.clientWidth - leftMost;
        // console.log('Docked ' + this.el.nativeElement.className + ' fill: '+ this.top + ' height:' + this.height);
    }

    private dockLeft(parentRect: ClientRect, siblings: HTMLCollection) {
        let rightMost = 0;
        let topMost = 0;
        let leftMost = 0;
        let bottomMost = 0;

        for (let index = 0; index < siblings.length; index++) {
            let element: Xelement = siblings[index];
            if (element === this.el.nativeElement) {
                break;
            }
            if (element.docked) {
                let rect = element.getBoundingClientRect();
                if (element.docked === 'left' &&
                    (this.isBetween(this.top, rect.top, rect.top + rect.height) ||
                        (this.isBetween(this.top + this.height, rect.top, rect.top + rect.height)))) {
                    leftMost = Math.max(leftMost, (rect.left + rect.width));
                }
                if (element.docked === 'top' &&
                    (this.isBetween(this.left, rect.left, rect.left + rect.width) ||
                        (this.isBetween(this.left + this.width, rect.left, rect.left + rect.width)))) {
                    topMost = Math.max(topMost, (rect.height));
                }
            }
        }
        this.left = leftMost;
        this.top = topMost;
        this.height = this.parent.clientHeight - topMost;
        //        console.log('Docked ' + this.el.nativeElement.className + ' left: '+ this.top + ' height:' + this.height);

    }

    private dockTop(parentRect: ClientRect, siblings: HTMLCollection) {
        let rightMost = 0;
        let topMost = 0;
        let leftMost = 0;
        let bottomMost = 0;

        for (let index = 0; index < siblings.length; index++) {
            let element: Xelement = siblings[index];
            if (element === this.el.nativeElement) {
                break;
            }
            if (element.docked) {
                let rect = element.getBoundingClientRect();
                if (element.docked === 'left' &&
                    (this.isBetween(this.top, rect.top, rect.top + rect.height) ||
                        (this.isBetween(this.top + this.height, rect.top, rect.top + rect.height)))) {
                    leftMost = Math.max(leftMost, (rect.left + rect.width));
                }
                if (element.docked === 'top') {

                    // &&
                    // ( this.isBetween( this.left, rect.left, rect.left + rect.width ) ||
                    //     ( this.isBetween( this.left + this.width, rect.left, rect.left + rect.width ) ) ) ) {
                    // topMost = Math.max( topMost, ( rect.top + rect.height ) );
                    // console.log(this.el.nativeElement.className + ' Add:'+ (rect.height) + ' from ' + element.className);
                    topMost += (rect.height);
                }
            }
        }
        this.left = leftMost;
        this.top = topMost;
        this.width = this.parent.clientWidth - leftMost;
        // console.log('Docked ' + this.el.nativeElement.className + ' top: '+ this.top + ' height:' + this.height);
    }

    private isBetween(a: number, x: number, y: number): boolean {
        return a >= x && a <= y;
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/dock.directive.ts